import { Injectable } from "@angular/core";
import { concatMap, forkJoin, map, mergeMap, Observable, of, tap, toArray } from "rxjs";
import { toReportTemplateDto } from "../sync-mapper";
import { OnPremiseSyncDataState } from "./on-premise-sync-state.service";
import { IndividualReportTemplateDbService } from "../../database/individual-report-template-db.service";
import { ReportTemplateService } from "../../http-api/report-template.service";
import { IndividualReportTemplateSchema } from "../../../_offline/models/individual-report-template.schema";
import { ReportTemplate } from "../../../_offline/models/report-preview/report-template";

@Injectable({
  providedIn: 'root'
})
export class ReportTemplateSyncService {

  constructor(
    private reportTemplateService: ReportTemplateService,
    private individualReportTemplateDbService: IndividualReportTemplateDbService,
    private syncState: OnPremiseSyncDataState,
  ) { }

  public createReportTemplates(): Observable<ReportTemplate[]> {
    const subjectModelIds = Object.keys(this.syncState.syncDataState.inspectionTemplate);
    if (subjectModelIds.length === 0) {
      return of([]);
    }

    const reportTemplateObservables = subjectModelIds.map(subjectModelId => this.createReportTemplatesFromSubjectId(subjectModelId));

    return forkJoin(reportTemplateObservables).pipe(
      map(arrayOfReportTemplateArrays => arrayOfReportTemplateArrays.flat())
    );
  }

  public createReportTemplatesFromSubjectId(subjectModelId: string): Observable<ReportTemplate[]> {
    return this.individualReportTemplateDbService
      .getAllOnPremise(subjectModelId)
      .pipe(
        concatMap(reportTemplates => reportTemplates),
        mergeMap(reportTemplate => this.postReportTemplate(reportTemplate, subjectModelId)),
        toArray(),
      );
  }

  private postReportTemplate(reportTemplateSchema: IndividualReportTemplateSchema, subjectModelId: string): Observable<ReportTemplate> {
    const reportTemplateNew = toReportTemplateDto(reportTemplateSchema, this.syncState.getInspectionTemplateId(subjectModelId));
    const createdReportTemplate = this.reportTemplateService.addReportTemplate(reportTemplateNew);
    return createdReportTemplate.pipe(
      tap(reportTemplate => this.syncState.updateReportTemplate(reportTemplateSchema.id, reportTemplate.id)),
    );
  }
}
